export default __webpack_public_path__ + "static/media/default-org-logo.5ea7c913.svg";